import debounce from 'lodash.debounce';
export const withDebounce = (callback = () => {}, daley = 300) => {
  return debounce(callback, daley);
};
